import React, { useEffect } from 'react';
import OverlayPlayer from '../components/OverlayPlayer';

/**
 * Page dédiée au lecteur d'overlays pour OBS
 *
 * Cette page est conçue pour être utilisée comme source navigateur dans OBS.
 * Elle affiche une interface minimale et transparente qui affiche les overlays
 * associés aux récompenses Twitch.
 *
 * URL: /overlay-player
 */
export default function OverlayPlayerPage() {
  // OBS: on force un fond entièrement transparent pour la route /overlay-player
  // (sinon OBS peut afficher le fond par défaut du navigateur/source).
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById('root');

    // Ajouter une classe CSS pour cibler spécifiquement cette page
    html.classList.add('overlay-player-page');
    body.classList.add('overlay-player-page');
    if (root) {
      root.classList.add('overlay-player-page');
    }

    // Sauvegarder les styles précédents
    const prevHtmlBg = html.style.backgroundColor;
    const prevHtmlBgImg = html.style.backgroundImage;
    const prevBodyBg = body.style.backgroundColor;
    const prevBodyBgImg = body.style.backgroundImage;
    const prevBodyMargin = body.style.margin;
    const prevBodyOverflow = body.style.overflow;
    const prevRootBg = root ? root.style.backgroundColor : '';
    const prevRootBgImg = root ? root.style.backgroundImage : '';

    // Forcer la transparence via inline styles (priorité maximale)
    html.style.backgroundColor = 'transparent';
    html.style.backgroundImage = 'none';
    body.style.backgroundColor = 'transparent';
    body.style.backgroundImage = 'none';
    body.style.margin = '0';
    body.style.overflow = 'hidden';
    if (root) {
      root.style.backgroundColor = 'transparent';
      root.style.backgroundImage = 'none';
    }

    // Masquer le pseudo-élément body::before qui crée le fond animé
    const style = document.createElement('style');
    style.id = 'overlay-player-transparent-bg';
    style.textContent = `
      body.overlay-player-page::before {
        display: none !important;
      }
    `;
    document.head.appendChild(style);

    return () => {
      // Restaurer les styles précédents
      html.classList.remove('overlay-player-page');
      body.classList.remove('overlay-player-page');
      if (root) {
        root.classList.remove('overlay-player-page');
      }

      html.style.backgroundColor = prevHtmlBg;
      html.style.backgroundImage = prevHtmlBgImg;
      body.style.backgroundColor = prevBodyBg;
      body.style.backgroundImage = prevBodyBgImg;
      body.style.margin = prevBodyMargin;
      body.style.overflow = prevBodyOverflow;
      if (root) {
        root.style.backgroundColor = prevRootBg;
        root.style.backgroundImage = prevRootBgImg;
      }

      // Supprimer le style injecté
      const injectedStyle = document.getElementById(
        'overlay-player-transparent-bg'
      );
      if (injectedStyle) {
        injectedStyle.remove();
      }
    };
  }, []);

  return <OverlayPlayer standalone={true} />;
}
